import React, { FC } from 'react'
import './marketo.css'
import useMarketo from './useMarketoHook'

type Props = {
  formCallbacks?: any
  formData: any
  marketoJsScript?: any
}

const MarketoForm: FC<Props> = ({ formCallbacks, formData, marketoJsScript }) => {
  const formId = formData?.formId

  function Form() {
    const munchkinId = '995-XLT-886'
    const baseUrl = '//start.uipath.com'
    if (!(baseUrl && munchkinId && formId)) return null

    const marketoParams = {
      baseUrl: baseUrl,
      munchkinId: munchkinId,
      formId: formId,
      callback: (form: any) => {
        formCallbacks && formCallbacks(form)
      },
      marketoJsScript: marketoJsScript,
    }

    useMarketo(marketoParams)
    const formIdsInitHiddenCSS = [1003, 1232, 1236, 1244, 1254, 8521, 3194, 1219, 11467, 14050]

    let customStyles = {}
    if (formIdsInitHiddenCSS.includes(formId)) {
      customStyles = {
        visibility: 'hidden',
        opacity: 0,
      }
    }

    return (
      <div className="MarketoForm">
        <form id={`mktoForm_${formId}`} style={customStyles} data-cy="marketo" />
      </div>
    )
  }

  return formId ? <Form /> : null
}

export default MarketoForm
